import Vue from 'vue'
import VueRouter from 'vue-router'
import {
  Index,
  Home,
  Address,
  Screen,
  Search,
  PositionDetails,
  Profile,
  Edit,
  Collect,
  Resume,
  Experience,
  JobSearch,
  Interview,
  ViewDetails,
  ComponyDetails,
  HomeBoss,
  Login,
  Register,
  Information,
  Ment,
  EditPosition,
  Description,
  interviewResult,
  Account,
  SMS,
  ForgetPassWord,
  setPassWord,
  userRegister,
  soliderInfo,
  Ideology,
  Interpretation,
  Train,
  Article,
  Artcomponent,
  Video,
  Activity,
  ActiveDetails,
  Online,
  interDetails,
  jobSearch,
  Recommend,
  ResumeDetails,
  Mine,
  companyInvite,
  contant,
  board,
  life
} from './path'
Vue.use(VueRouter)

const routes = [{
    path: '/',
    redirect: '/index',
    component: Index
  },
  {
    path: '/index',
    name: 'Index',
    component: Index
  },
  {
    path: '/home',
    name: 'Home',
    component: Home
  },
  {
    path: '/home/address',
    name: 'Address',
    component: Address
  },
  {
    path: '/home/screen',
    name: 'Screen',
    component: Screen
  },
  {
    path: '/home/search',
    name: 'Search',
    component: Search
  },
  {
    path: '/position/positionDetails',
    name: 'positionDetails',
    component: PositionDetails
  },
  {

    path: '/position/componyDetails',
    name: 'ComponyDetails',
    component: ComponyDetails
  },
  {
    path: '/profile',
    name: 'Profile',
    component: Profile
  },
  {
    path: '/profile/edit',
    name: 'Edit',
    component: Edit
  },
  {
    path: '/profile/collect',
    name: 'Collect',
    component: Collect
  },
  {
    path: '/profile/resume',
    name: 'Resume',
    component: Resume
  },
  {
    path: '/experience',
    name: 'Experience',
    component: Experience
  },
  {
    path: '/experience/jobSearch',
    name: 'JobSearch',
    component: JobSearch
  },
  {
    path: '/Interview',
    name: 'Interview',
    component: Interview
  },
  {
    path: '/interview/viewDetails',
    name: 'ViewDetails',
    component: ViewDetails
  },

  {
    path: '/login',
    name: 'Login',
    component: Login,
    children: [{
        path: 'account',
        name: 'Account',
        component: Account,
      },
      {
        path: 'SMS',
        name: 'SMS',
        component: SMS
      }
    ]
  },
  {
    path: '/login/forgetPassWord',
    name: 'ForgetPassWord',
    component: ForgetPassWord,
  },
  {
    path: '/login/setPassWord',
    name: 'setPassWord',
    component: setPassWord,
  },
  {
    path: '/register',
    name: 'userRegister',
    component: userRegister,
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/register/soliderInfo',
    name: 'soliderInfo',
    component: soliderInfo,
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/ideology',
    name: 'Ideology',
    component: Ideology,
  },
  {
    path: '/interpretation',
    name: 'Interpretation',
    component: Interpretation,
  },
  {
    path: '/train',
    name: 'Train',
    component: Train,
  },
  {
    path: '/ideology/article',
    name: 'Article',
    component: Article,
    children: [{
        path: 'articleDetails',
        name: 'Artcomponent',
        component: Artcomponent
      },
      {
        path: 'videoDetails',
        name: 'videoDetails',
        component: Video
      }
    ]
  },
  {
    path: '/train/activity',
    name: 'Activity',
    component: Activity,
  },
  {
    path: '/train/activeDetails',
    name: 'ActiveDetails',
    component: ActiveDetails
  },
  {
    path: '/train/online',
    name: 'Online',
    component: Online
  },
  {
    path: '/interpretation/interDetails',
    name: 'interDetails',
    component: interDetails
  },
  {
    path: '/contant/index',
    name: 'contant',
    component: contant
  },
  {
    path: '/contant/board',
    name: 'board',
    component: board
  },
  /**
   *公司端
   * */
  {
    path: '/home/index',
    name: 'HomeBoss',
    component: HomeBoss,
  },
  {
    path: '/recommend/index',
    name: 'Recommend',
    component: Recommend,
  },
  {
    path: '/logReg/register',
    name: 'Register',
    component: Register
  },
  {
    path: '/logReg/Information',
    name: 'Information',
    component: Information,

  },
  {
    path: '/management',
    name: 'Ment',
    component: Ment
  },
  {
    path: '/management/editPosition',
    name: 'EditPosition',
    component: EditPosition,
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/management/description',
    name: 'Description',
    component: Description
  },
  {
    path: '/management/interviewResult',
    name: 'interviewResult',
    component: interviewResult
  },
  {
    path: '/recommend/details',
    name: 'resumeDetails',
    component: ResumeDetails
  },
  {
    path: '/mine/index',
    name: 'Mine',
    component: Mine
  },
  {
    path: '/profile/companyInvite',
    name: 'companyInvite',
    component: companyInvite
  },
  // 生活服务
  {
    path: '/life',
    name: 'Life',
    component: life,
  },
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router